import React from 'react';
import { ACCESS_STEPS } from '../../data/catio';
export function AccessSection() {
  return <section aria-labelledby="access-title" className="bg-stone py-12 sm:py-16" data-id="element-113" data-mp="3epk6tfw4erga">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-114" data-mp="3sgffar2pj6jc">
        <h2 id="access-title" className="font-display text-[1.8rem] leading-[1.12] text-ink sm:text-[2.4rem]" data-id="element-115" data-mp="3sfnlnlso7ivp">
          Start Building Minutes After Purchase
        </h2>
        <ol className="mt-6 grid gap-px overflow-hidden rounded-[14px] border border-line bg-line sm:grid-cols-2 lg:grid-cols-4" data-id="element-116" data-mp="30pj5y0fuvk0t">
          {ACCESS_STEPS.map((step, index) => <li key={step} className="flex items-center gap-4 bg-paper px-5 py-4 lg:flex-col lg:items-start lg:gap-3 lg:py-6" data-id="element-117" data-mp="39qqona5w2c9s" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ember font-tech text-[15px] font-semibold text-ember" data-id="element-118" data-mp="oz70yh76uotd">
                {index + 1}
              </span>
              <span className="text-[1rem] font-medium leading-snug text-ink" data-id="element-119" data-mp="1cqcl6nazd1ly">{step}</span>
            </li>)}
        </ol>
      </div>
    </section>;
}